import PropTypes from 'prop-types';
import React, {cloneElement, useCallback, useEffect, useRef, useState} from 'react';
import styled from 'styled-components';

function DropdownScrollable({children}) {
	const ref = useRef();

	const [isOpen, setIsOpen] = useState(false);
	const handleOnScroll = useCallback(() => {
		setIsOpen(false);
	}, []);

	useEffect(() => {
		const scrollables = [tryGetClosest(ref.current, '.customScrollbar')];

		const leaf = scrollables[0];
		if (leaf) {
			leaf.addEventListener('scroll', handleOnScroll);
			let element = tryGetClosest(leaf.parentElement, '.customScrollbar');

			let i = 0;
			while (element) {
				element.addEventListener('scroll', handleOnScroll);
				scrollables.push(element);
				element = tryGetClosest(element.parentElement, '.customScrollbar');
				i++;
			}
		}

		return () => {
			for (const scrollable of scrollables) {
				scrollable.removeEventListener('scroll', handleOnScroll);
			}
		};
	}, [handleOnScroll]);

	return (
		<StyledDropdownScrollable
			className="DropdownScrollable"
			ref={ref}
			onClick={(e) => {
				e.stopPropagation();
			}}
		>
			{cloneElement(children, {isOpen, setIsOpen})}
		</StyledDropdownScrollable>
	);
}

DropdownScrollable.propTypes = {
	children: PropTypes.node
};

function tryGetClosest(element, selector) {
	try {
		return element.closest(selector);
	} catch {
		return false;
	}
}

export default DropdownScrollable;

const StyledDropdownScrollable = styled.section`
	min-height: var(--px-85);
	height: 100%;
	display: flex;
	align-items: center;
	width: var(--px-35);
	justify-content: center;
`;
